enum SearchType {
    Advanced = 'Advanced',
    Basic = 'Basic',
}

export default SearchType;
